import React, { useContext } from 'react';
import { UAContext } from '@quentin-sommer/react-useragent';
import PropTypes from 'prop-types';
import { singularize } from 'inflected';
import { acceptedFor } from 'story-media/helper';
import { Label } from './styled';
import { Text, Flex } from 'rebass';

const NewStoryWithMediumButton = ({ type, children, disabled, handleChange, label, ...props }) => {
  const {
    uaResults: { android },
  } = useContext(UAContext);
  const accept = acceptedFor[type];
  const acceptAny = `${acceptedFor.images},${acceptedFor.audios},${acceptedFor.videos}`;

  return (
    <Label htmlFor={`new_story_with_${type}`} disabled={disabled} >
      <input
        id={`new_story_with_${type}`}
        type="file"
        accept={type === 'any' ? acceptAny : accept}
        disabled={disabled}
        multiple
        onChange={handleChange}
        {...props}
      />
      <Flex justifyContent="space-between" width="100%" alignItems="center">
        <Flex>
          {children}
          <Text fontFamily="Poppins" fontSize={18} lineHeight="165%" fontWeight={500} color="#0E0E0E" >{label}</Text>
        </Flex>
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
          <path d="M0.514648 2.34292L1.92885 0.928711L8.99995 7.99975L1.92885 15.0709L0.514648 13.6567L6.17155 7.99975L0.514648 2.34292Z" fill="#64748B" />
        </svg>
      </Flex>
    </Label>
  );
};

NewStoryWithMediumButton.propTypes = {
  type: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  handleChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
};

export default NewStoryWithMediumButton;
